import React from 'react';
import MUIDrawer from "@mui/material/Drawer";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Close from "@mui/icons-material/Close";
import * as styles from './Drawer.style';
export const Drawer = ({ dataQa, id, actions, isOpened, drawer, setAnchorEl }) => {
    const handleClose = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setAnchorEl(null);
    };
    const handleAction = (event, action) => {
        action && action.action(id);
        handleClose(event);
    };
    return (React.createElement(MUIDrawer, { anchor: drawer === null || drawer === void 0 ? void 0 : drawer.anchor, "data-qa": `${dataQa}-actionDrawer`, open: isOpened, onClose: handleClose, sx: styles.drawer },
        React.createElement(DialogTitle, { "data-qa": `${dataQa}-actionDrawerTitle`, sx: styles.title }, drawer === null || drawer === void 0 ? void 0 :
            drawer.title,
            (drawer === null || drawer === void 0 ? void 0 : drawer.showCloseIcon) && (React.createElement(IconButton, { "aria-label": "close", "data-qa": `${dataQa}-actionDrawerClose`, onClick: handleClose, sx: {
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                } },
                React.createElement(Close, null)))),
        Array.isArray(actions) &&
            actions.length > 0 &&
            actions.map((action, i) => {
                return (React.createElement(MenuItem, { key: `menuItem-${i}`, onClick: (event) => handleAction(event, action), "data-qa": `${dataQa}-actionDrawerItem`, sx: styles.menuItemStyle },
                    action.icon,
                    action.title));
            })));
};
